////////////////////////////////////////////////////////////
//     							                          //
//  Program: OnKeyPressEvent.jsx                          //
//  Application: Common Components                        //
//  Option: For to prevent specific key value             //
//  Developer: CV  						                  //
//  Date: 2021-04-13                                      //
////////////////////////////////////////////////////////////

import { Component } from "react";

class OnKeyPressEvent extends Component {
  setTheme = () => {
    var url = window.location.href;
    var kini = url.includes("kini");
    var theme = kini ? "kini" : "oh";

    return theme == "kini"
      ? "./assets/scss/kini_html.scss"
      : "./assets/scss/oh_html.scss";
  };

  phoneValidation = (event) => {
    // 0-9, space, +, -, ()
    let charCodeArray = [32, 40, 41, 43, 45];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  mobileValidation = (event) => {
    // 0-9, +
    let charCodeArray = [43];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  floatValidation = (event) => {
    // 0-9, dot
    let charCodeArray = [46];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  numberValidation = (event) => {
    // 0-9
    let charCodeArray = [];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  numSpaceValidation = (event) => {
    // 0-9, space
    let charCodeArray = [32];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  numSpaceDashValidation = (event) => {
    // 0-9, space, dash
    let charCodeArray = [32, 45];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  alphaValidation = (event) => {
    // A-Z
    let charCodeArray = [];
    if (
      (event.charCode >= 97 && event.charCode <= 122) ||
      (event.charCode >= 65 && event.charCode <= 90) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  alphaSpaceValidation = (event) => {
    // A-Z, space
    let charCodeArray = [32];
    if (
      (event.charCode >= 97 && event.charCode <= 122) ||
      (event.charCode >= 65 && event.charCode <= 90) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  alphaNumValidation = (event) => {
    // 0-9, A-Z
    let charCodeArray = [];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      (event.charCode >= 97 && event.charCode <= 122) ||
      (event.charCode >= 65 && event.charCode <= 90) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  alphaNumSpaceValidation = (event) => {
    // 0-9, A-Z, space
    let charCodeArray = [32];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      (event.charCode >= 97 && event.charCode <= 122) ||
      (event.charCode >= 65 && event.charCode <= 90) ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  excludeSpaceValidation = (event) => {
    // exclude space
    let charCodeArray = [32];
    if (charCodeArray.indexOf(event.charCode) > -1) {
      event.preventDefault();
    } else {
      return true;
    }
  };

  timeValidation = (event) => {
    let charCodeArray = [];
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      event.charCode == 58 ||
      charCodeArray.indexOf(event.charCode) > -1
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  //for thousand seprattor
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  //for thousand seprattor having decimal more than 2 (i.e. 4220.1200)
  numberWithCommasForDecimal(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  // For rounded point value
  customeToFixed(num, precision = 2) {
    if (num === "" || num === null || num === "NaN") {
      num = 0;
    }
    return parseFloat(
      +(Math.round(+(num + "e" + precision)) + "e" + -precision),
    ).toFixed(precision);
  }

  // For without rounded point value
  customeToFixedDown(num, precision = 2) {
    if (num === "" || num === null || num === "NaN") {
      num = 0;
    }
    return Math.trunc(num * Math.pow(10, precision)) / Math.pow(10, precision);
  }

  // To check users access permission
  checkPermission(route) {
    let permissions = localStorage.getItem("permissions")
      ? localStorage.getItem("permissions")
      : [];
    if (permissions.length > 0) {
      let permissions1 = permissions.split(",");
      //for matching permission slug (if not exist,it will return -1)
      if (permissions1.indexOf(route) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  dispNumber(n, d, prefix, suffix) {
    // convert n to a display number with d decimals
    var s = Number(n);
    if (s >= 0) {
      s = this.inpNumber(n, d) + "&nbsp;";
    } else {
      n = Math.abs(n);
      s = '<span class="negnum">(' + this.inpNumber(n, d) + ")</span>";
    }
    return (prefix ? prefix : "") + s + (suffix ? suffix : "");
  }

  inpNumber(n, d) {
    if (Math.floor(n) != n) {
      n = Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
    }
    var s = n.toString();
    // insert commas
    var p = s.indexOf(".");
    if (p < 0) {
      p = s.length;
      if (d > 0) {
        s = s + ".";
        for (var i = 0; i < d; i++) s = s + "0";
      }
    } else if (s.length - p - 1 < d) {
      for (i = s.length - p - 1; i < d; i++) s = s + "0";
    }
    for (i = p - 3; i > 0; i -= 3) s = s.substr(0, i) + "," + s.substr(i);
    return s;
  }

  generateSlug(length = 12) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  validateEmail(email) {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (regex.test(email) === false) {
      return false;
    } else {
      return true;
    }
  }

  validatePassword(pw) {
    const uppercaseRegExp = /(?=.*?[A-Z])/;
    const lowercaseRegExp = /(?=.*?[a-z])/;
    const digitsRegExp = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp = /.{6,}/;
    if (!uppercaseRegExp.test(pw)) {
      return "Your password must contain at least one upper case characters(A-Z).";
    } else if (!lowercaseRegExp.test(pw)) {
      return "Your password must contain at least one lower case character(a-z).";
    } else if (!digitsRegExp.test(pw)) {
      return "Your password must contain at least one number (0-9).";
    } else if (!specialCharRegExp.test(pw)) {
      return "Your password must contain at least one symbol (#?!@$%^&*-).";
    } else if (!minLengthRegExp.test(pw)) {
      return "Your password must have at least 6 characters long.";
    } else {
      return "";
    }
  }

  getBrandSlug() {
    if (
      [
        "dev.kinibeachhaus.com",
        "https://dev.kinibeachhaus.com",
        "stg.kinibeachhaus.com",
        "https://stg.kinibeachhaus.com",
        "www.kinibeachhaus.com",
        "https://www.kinibeachhaus.com",
        "localhost:3000",
      ].includes(global.host)
    ) {
      return "kini-beach-haus";
    } else if (["www.thefredrick-apartments.com"].includes(global.host)) {
      // return "the-fredrick"; //dev
      // return "the-fredrick"; //stg
      return "the-fredrick"; // prd
    } else if (
      [
        "www.merino-apartments.com",
        "https://www.merino-apartments.com",
        "merino-apartments.com",
      ].includes(global.host)
    ) {
      // return "merino"; //dev
      //return "merino"; //stg
      return "merino"; // prd
    } else if (
      [
        "www.acadiancrossing-apartments.com",
        "https://www.acadiancrossing-apartments.com",
        "acadiancrossing-apartments.com",
      ].includes(global.host)
    ) {
      // return "merino"; //dev
      //return "merino"; //stg
      return "acadian-crossing-lafayette"; // prd
    } else {
      return "kini-beach-haus";
    }
  }

  getPropertySlug() {
    // if (
    //   [
    //     "stg.kinibeachhaus-lasolas.com",
    //     // "https://stg.kinibeachhaus-lasolas.com",
    //     "https://www.kinibeachhaus-lasolas.com",
    //     "www.kinibeachhaus-lasolas.com",
    //     "localhost:3002",
    //     "fort-lauderdale-fl",
    //   ].includes(global.host)
    // ) {
    //   return "kini-beach-haus-las-olas"; // Prd
    // } else if (
    //   ["www.thefredrick-tempe.com", "tempe-az"].includes(global.host)
    // ) {
    //   return "the-fredrick-tempe"; //prd
    // } else

    if (
      [
        "www.merino-scottsdale.com",
        "https://www.merino-scottsdale.com",
        "https://merino-scottsdale.com",
        "merino-scottsdale.com",
        "scottsdale-az",
      ].includes(global.host)
    ) {
      return "merino-scottsdale"; //prd
    } else if (
      [
        "https://www.orionhaus-scottsdale.com",
        "https://orionhaus-scottsdale.com",
        "www.orionhaus-scottsdale.com",
        "orionhaus-scottsdale.com",
        "scottsdale-az",
      ].includes(global.host)
    ) {
      return "merino-scottsdale"; //prd
    } else if (
      [
        "https://www.acadiancrossing-lafayette.com",
        "https://acadiancrossing-lafayette.com",
        "www.acadiancrossing-lafayette.com",
        "acadiancrossing-lafayette.com",
        "lafayette-la",
      ].includes(global.host)
    ) {
      return "acadian-crossing-lafayette"; //prd
    } else if (["Austin"].includes(global.host)) {
      return "highgrove-austin"; //prd
    } else if (["east-hampton-ny"].includes(global.host)) {
      return "the-hampton-hideaway"; //prd
    } else if (["camdenton-mo"].includes(global.host)) {
      return "ember-ridge"; //prd
    } else if (["cin-nashville-tn"].includes(global.host)) {
      return "cindy-s-home"; //prd
    } else if (["cre-austin-tx"].includes(global.host)) {
      return "creekstone-apartments"; //prd
    } else if (["san-macros-tx"].includes(global.host)) {
      return "the-merriman"; //prd
    } else if (["crg-nashville-tn"].includes(global.host)) {
      return "carriage-house"; //prd
    } else if (["camdenton-mo"].includes(global.host)) {
      return "ember-ridge"; //prd
    } else if (["san-antonio-tx"].includes(global.host)) {
      return "pecan-springs"; //prd
    } else if (["twr-lockhart-tx"].includes(global.host)) {
      return "the-wonderyard-lockhart"; //prd
    } else if (["tsl-austin-tx"].includes(global.host)) {
      return "the-shiloh"; //prd
    } else if (["lil-antonio-tx"].includes(global.host)) {
      return "the-lila"; //prd
    } else if (["pro-antonio-tx"].includes(global.host)) {
      return "providence-estates"; //prd
    } else if (["pal-antonio-tx"].includes(global.host)) {
      return "schertz-tx"; //prd
    } else if (["bax-austin-tx"].includes(global.host)) {
      return "baxter-at-westwood"; //prd
    } else if (["fie-austin-tx"].includes(global.host)) {
      return "the-fielder"; //prd
    } else if (["bar-austin-tx"].includes(global.host)) {
      return "the-barstow"; //prd
    } else if (["son-austin-tx"].includes(global.host)) {
      return "sona-apartments"; //prd
    } else if (["pat-austin-tx"].includes(global.host)) {
      return "the-patten-east"; //prd
    } else if (["sai-austin-tx"].includes(global.host)) {
      return "the-saint-mary"; //prd
    } else if (["hen-austin-tx"].includes(global.host)) {
      return "the-henry-heights"; //prd
    } else if (["low-austin-tx"].includes(global.host)) {
      return "the-lowell-at-mueller"; //prd
    } else if (["res-austin-tx"].includes(global.host)) {
      return "reserve-walnut-creek"; //prd
    } else if (["col-austin-tx"].includes(global.host)) {
      return "collins-square"; //prd
    } else if (["nel-austin-tx"].includes(global.host)) {
      return "the-nelson"; //prd
    } else if (["tay-austin-tx"].includes(global.host)) {
      return "2800-taylor-street"; //prd
    } else if (["sbh-nashville-tn"].includes(global.host)) {
      return "nashville-shelby"; //prd
    }else if (["ent-san-macros-tx"].includes(global.host)) {
      return "the-entrada-at-san-marcos"; //prd
    } else {
      return "highgrove-austin"; // Prd
    }
  }

  getPropertySlugByCity(city = "") {
    // if (["fort-lauderdale-fl"].includes(city)) {
    //   return "kini-beach-haus-las-olas"; // Prd
    // } else if (["tempe-az"].includes(city)) {
    //   return "the-fredrick-tempe"; //prd
    // } else

    if (["scottsdale-az"].includes(city)) {
      return "merino-scottsdale"; //prd
    } else if (["merino-scottsdale-az"].includes(city)) {
      return "merino-scottsdale"; //prd
    } else if (["lafayette-la"].includes(city)) {
      return "acadian-crossing-lafayette"; //prd
    } else if (["Austin"].includes(city)) {
      return "highgrove-austin"; //prd
    } else if (["east-hampton-ny"].includes(city)) {
      return "the-hampton-hideaway"; //prd
    } else if (["cin-nashville-tn"].includes(city)) {
      return "cindy-s-home"; //prd
    } else if (["crg-nashville-tn"].includes(city)) {
      return "carriage-house"; //prd
    } else if (["cre-austin-tx"].includes(city)) {
      return "creekstone-apartments"; //prd
    } else if (["san-macros-tx"].includes(city)) {
      return "the-merriman"; //prd
    } else if (["san-antonio-tx"].includes(city)) {
      return "pecan-springs"; //prd
    } else if (["camdenton-mo"].includes(city)) {
      return "ember-ridge"; //prd
    } else if (["twr-lockhart-tx"].includes(city)) {
      return "the-wonderyard-lockhart"; //prd
    } else if (["tsl-austin-tx"].includes(city)) {
      return "the-shiloh"; //prd
    } else if (["lil-antonio-tx"].includes(city)) {
      return "the-lila"; //prd
    } else if (["pro-antonio-tx"].includes(city)) {
      return "providence-estates"; //prd
    } else if (["pal-antonio-tx"].includes(city)) {
      return "schertz-tx"; //prd
    } else if (["bax-austin-tx"].includes(city)) {
      return "baxter-at-westwood"; //prd
    } else if (["fie-austin-tx"].includes(city)) {
      return "the-fielder"; //prd
    } else if (["bar-austin-tx"].includes(city)) {
      return "the-barstow"; //prd
    } else if (["son-austin-tx"].includes(city)) {
      return "sona-apartments"; //prd
    } else if (["pat-austin-tx"].includes(city)) {
      return "the-patten-east"; //prd
    } else if (["sai-austin-tx"].includes(city)) {
      return "the-saint-mary"; //prd
    } else if (["hen-austin-tx"].includes(city)) {
      return "the-henry-heights"; //prd
    } else if (["low-austin-tx"].includes(city)) {
      return "the-lowell-at-mueller"; //prd
    } else if (["res-austin-tx"].includes(city)) {
      return "reserve-walnut-creek"; //prd
    } else if (["col-austin-tx"].includes(city)) {
      return "collins-square"; //prd
    } else if (["nel-austin-tx"].includes(city)) {
      return "the-nelson"; //prd
    } else if (["tay-austin-tx"].includes(city)) {
      return "2800-taylor-street"; //prd
    } else if (["sbh-nashville-tn"].includes(city)) {
      return "nashville-shelby"; //prd
    }else if (["ent-san-macros-tx"].includes(city)) {
      return "the-entrada-at-san-marcos"; //prd
    } else {
      return "highgrove-austin"; // Prd
    }
  }
  getS3ImageUrl(imageName = "", imagePath = "website/images") {
    return (
      process.env.REACT_APP_S3_BUCKET_URL + "/" + imagePath + "/" + imageName
    );
  }
}

export default OnKeyPressEvent;
